<template>
    <div class="key-topics" v-if="items && items.length">
        <div class="container">
            <h2 v-html="title"></h2>
            <div class="row row--20">
                <div
                    v-for="(item, index) of items"
                    :key="index"
                    :class="[ item['big-format'] ? 'col-default-8 col-mobile-12' : 'col-default-4 col-mobile-12']"
                >
                    <a
                        class="key-topics__card"
                        :href="item.link"
                        :target="[ item['external-link'] ? '_blank' : '_self' ]"
                        :data-target="`KeyTopics${index + 1}MainPage`"
                        :data-label="`keytopic${index + 1}`"
                        data-category="keytopics"
                        @click.self="targetAnalytics"
                    >
                        <div class="key-topics__card-wrapper" :style="styleHelperImage(item)">
                            <span class="key-topics__card--caption" v-html="item.type"></span>
                            <p
                                v-html="item.name"
                                class="key-topics__card--title"
                                :class="{ 'key-topics__card--link-external' : item['external-link'] }"
                            ></p>
                            <div class="key-topics__card--description" v-if="item.detail">
                                <span class="key-topics__spacer"></span>
                                <div v-html="item.detail"></div>
                            </div>
                        </div>
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { targetAnalytics } from '@/utils/util.js'

export default {
    name: 'key-topics',
    props: {
        data: {
            type: Array
        }
    },
    data() {
        return {
            items: this.data,
            title: localize({
                'ru': 'Ключевые темы',
                'en': 'Key Topics'
            }),
            targetAnalytics
        }
    },
    methods: {
        styleHelperImage (item) {
            const image = item.image
            let style = ''


            if (image) {
                style = `background-image: url('${item['big-format'] ? image.full : image.square}');`
            } else {
                style = 'background-color: #F5F5F5;'
            }

            return style
        }
    },
    watch: {
        device (value) {
            if (value === 'v-mobile' || value === 'mobile') {
                this.items = this.data.slice(0, 3)
            } else {
                this.items = this.data
            }
        }
    },
    computed: {
        device () {
            return this.$store.getters.device
        }
    }
}
</script>

<style lang="scss" src="./index.scss"></style>



// WEBPACK FOOTER //
// frontend/components/main-page/components/key-topics/index.vue